import * as React from "react";
import { LanguageProvider } from "./src/translations/LanguageContext";
import type { GatsbyBrowser } from "gatsby";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => <LanguageProvider>{element}</LanguageProvider>;
